<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25 mcc-style-nav-link"
    menu-class="dropdown-menu-media"
    right
    @hide="dropdownHide"
  >
    <template #button-content>
      <!-- <my-tooltip :tooltip="i18n('myTodo')">
        <feather-icon
          :badge="
            total +
              dataMessage.filter((o) => o.readStatus !== 1).length +
              dataNotice.filter((o) => o.readStatus !== 1).length
          "
          badge-classes="bg-danger"
          class="text-body "
          icon="BellIcon"
          size="20"
        />
      </my-tooltip> -->

      <div class="msg-box" style="">
        <img src="../../assets/images/logo/message-icon.svg" />
        <div v-if="filterNum > 0" class="msg-num">
          {{ filterNum | filterTodoNum }}
        </div>
      </div>
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header d-flex">
      <div
        class="dropdown-header d-flex"
        :class="{ current: currentTab === 1 }"
        @click="changeCurrentTab(1)"
      >
        <h4
          class="notification-title mb-0 mr-1"
          :class="{ current: currentTab === 1 }"
        >
          {{ i18n('message') }}
        </h4>
        <b-badge
          v-if="dataMessage.filter((o) => o.readStatus !== 1).length"
          pill
          variant="light-danger"
        >
          {{ dataMessage.filter((o) => o.readStatus !== 1).length }}
        </b-badge>
      </div>
      <div
        class="dropdown-header d-flex"
        :class="{ current: currentTab === 2 }"
        @click="changeCurrentTab(2)"
      >
        <h4
          class="notification-title mb-0 mr-1"
          :class="{ current: currentTab === 2 }"
        >
          {{ i18n('notifications') }}
        </h4>
        <b-badge
          v-if="dataNotice.filter((o) => o.readStatus !== 1).length"
          pill
          variant="light-danger"
        >
          {{ dataNotice.filter((o) => o.readStatus !== 1).length }}
        </b-badge>
      </div>
      <div
        class="dropdown-header d-flex"
        :class="{ current: currentTab === 3 }"
        @click="changeCurrentTab(3)"
      >
        <h4
          class="notification-title mb-0 mr-1"
          :class="{ current: currentTab === 3 }"
        >
          {{ i18n('todo') }}
        </h4>
        <b-badge v-if="total" pill variant="light-danger">
          {{ total }}
        </b-badge>
      </div>
    </li>
    <template>
      <!-- TODO -->
      <div class="scrollable-container scroll-area">
        <div v-show="currentTab === 3" class="media-list">
          <template v-if="data.length > 0">
            <b-media
              v-for="(item, index) in data"
              :key="index"
              vertical-align="top"
              class="media-todo-list"
            >
              <h4 class="media-heading">
                {{ item.processDefinitionName }}
              </h4>
              <p class="media-time" style="margin-bottom: 2px">
                Submit By {{ item.variables.createUserName }}
              </p>
              <span class="media-time">
                {{ formatTime(item.createTime) }}
              </span>
              <div class="media-list__btns">
                <feather-icon
                  icon="EditIcon"
                  class="text-primary cursor-pointer mr-1"
                  size="20"
                  @click="handleAuditClick(item)"
                />
              </div>
            </b-media>
          </template>
          <a-empty v-else class="media-list__empty" description="Not todo" />
        </div>

        <div v-show="currentTab === 1" class="media-list">
          <template v-if="dataMessage.length > 0">
            <b-media
              v-for="(item, index) in dataMessage"
              :key="index"
              vertical-align="top"
              :class="{ 'is-not-read': item.readStatus !== 1 }"
            >
              <h4 class="media-heading">
                {{ item.title }}
              </h4>
              <span class="media-time">
                {{ formatTime(item.releaseTime) }}
              </span>
              <div class="media-list__btns">
                <my-tooltip v-if="item.payload" :tooltip="i18n('detail')">
                  <feather-icon
                    icon="FileTextIcon"
                    class="text-primary cursor-pointer mr-1"
                    size="20"
                    @click="handleDetailClick(item)"
                  />
                </my-tooltip>
                <my-tooltip :tooltip="i18n('content')">
                  <feather-icon
                    icon="SearchIcon"
                    class="text-primary cursor-pointer mr-1"
                    size="20"
                    @click="handleContentClick(item)"
                  />
                </my-tooltip>
              </div>
            </b-media>
          </template>
          <a-empty v-else class="media-list__empty" description="Not message" />
        </div>

        <div v-show="currentTab === 2" class="media-list">
          <template v-if="dataNotice.length > 0">
            <b-media
              v-for="(item, index) in dataNotice"
              :key="index"
              vertical-align="top"
              :class="{
                'cursor-pointer': true,
                'is-not-read': item.readStatus !== 1,
                'is-read': item.readStatus == 1,
              }"
              @click="handleContentClick(item)"
            >
              <h4 class="media-heading">
                {{ item.title }}
              </h4>
              <span class="media-time">
                {{ formatTime(item.releaseTime) }}
              </span>
              <div class="media-content">
                <!-- {{ item.content }} -->
              </div>

              <div class="media-list__btns2">
                <!-- <my-tooltip v-if="item.payload" :tooltip="i18n('detail')">
                  <feather-icon
                    icon="FileTextIcon"
                    class="text-primary cursor-pointer mr-1"
                    size="20"
                    @click="handleDetailClick(item)"
                  />
                </my-tooltip> -->
                <my-tooltip
                  v-if="item.readStatus !== 1"
                  :tooltip="i18n('read')"
                >
                  <img
                    class="cursor-pointer"
                    src="@/assets/images/icons/Read.svg"
                    @click.stop="handleReadRow(item)"
                  />
                </my-tooltip>
              </div>
            </b-media>
          </template>
          <a-empty
            v-else
            class="media-list__empty"
            description="Not notifications"
          />
        </div>

        <!-- END -->
        <div class="media-btns">
          <!-- <div
            v-if="currentTab !== 3"
            @click="handleSelectedAll"
          >
            {{ hasSelectAll ? i18n('selectAll') : i18n('cancelSelect') }}
          </div> -->
          <div v-if="currentTab !== 3" @click="handleRead">
            {{ i18n('readAll') }}
          </div>
          <div @click="pageChange">
            {{ i18n('more') }}
          </div>
        </div>
      </div>
    </template>

    <c-modal
      :visible="modalShow"
      :title="i18n('audit')"
      body-class="process-modal"
      size="xl"
      @close="modalShow = false"
      @modelConfirm="formConfirm"
    >
      <template slot="content">
        <component
          :is="getComponentByOption"
          v-if="modalShow"
          ref="formRef"
          v-bind="componentParams"
        />
      </template>
    </c-modal>
    <b-modal v-model="confirmModalShow" :title="i18n('audit')" centered>
      <div style="background: #faebd6;">
        <my-form
          v-if="confirmModalShow"
          ref="overFormRef"
          :data="auditForm"
          :loading="auditLoading"
          :option="auditOption"
          :footer-visible="false"
          width="auto"
        />
      </div>
      <template #modal-footer>
        <b-button
          :disabled="auditLoading"
          variant="outline-primary"
          size="sm"
          @click="confirmModalShow = false"
        >
          {{ $t('_components.btns.cancel') }}
        </b-button>
        <b-button
          :disabled="auditLoading"
          variant="primary"
          size="sm"
          @click="handleModelConfirm"
        >
          {{ $t('_components.btns.confirm') }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="contentShow"
      body-class="process-modal"
      size="xl"
      centered
      :title="currentNotice.title"
      hide-footer
    >
      <div>
        <b-card-text>
          <div class="notice-content">
            <div
              v-if="currentNotice.title === 'WORKER WARNING LETTER'"
              class="message-viewBtn"
              @click.stop="handleViewClick(currentNotice)"
            >
              view
            </div>
            <div v-if="currentNotice.content">
              <iframe
                style="width: 100%;height: 600px;border:none"
                :srcdoc="currentNotice.content"
              />
            </div>
            <a-empty
              v-else
              class="media-list__empty"
              description="Not content"
            />
          </div>
          <div
            style="width: 100%;border-bottom: 1px solid #CAD6EB;transform: translateY(-5px);"
          />
          <element-component
            v-if="currentNotice.fileId"
            v-model="currentNotice.files"
            :disabled="true"
            :option="{ type: 'upload' }"
          />
          <div class="notice-footer">
            <p>{{ currentNotice.releaseTime }}</p>
          </div>
        </b-card-text>
      </div>
    </b-modal>
    <c-modal
      :visible="drawerShow"
      :title="i18n('detail')"
      body-class="process-modal"
      :footer="false"
      size="xl"
      @close="drawerShow = false"
      @modelConfirm="formConfirm"
    >
      <template slot="content">
        <viewPage
          v-if="drawerShow"
          :id="MessageProcessId"
          :process-id="MessageProcessId"
          :form-id="MessageFormId"
          process-key="workerWarningLetter"
          @close="handleDrawerClose"
        />
      </template>
    </c-modal>
    <!-- <c-drawer v-model="drawerShow" :before-close="handleBeforeClose">
      <viewPage
        v-if="drawerShow"
        :id="MessageProcessId"
        :process-id="MessageProcessId"
        :form-id="MessageFormId"
        process-key="workerWarningLetter"
        @close="handleDrawerClose"
      />
    </c-drawer> -->
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
  BCardText,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import todoAPi from '@/api/todo/index'
import CModal from '@/components/crud/modal.vue'
import MyForm from '@/components/myForm/index.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import components from '@/config/processOption'
import MyTooltip from '@/components/myTooltip.vue'
import ElementComponent from '@/components/elementComponent.vue'
import { deepClone } from '@/util/util'
import viewPage from '@/views/worker/apply/components/view.vue'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    // BLink,
    // BAvatar,
    // VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
    CModal,
    MyForm,
    MyTooltip,
    BCardText,
    ...components,
    ElementComponent,
    viewPage,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: false,
      getComponentByOption: '',
      componentParams: {},
      auditLoading: false,
      total: 0,
      data: [],
      modalShow: false,
      confirmModalShow: false,
      drawerShow: false,
      MessageProcessId: '',
      MessageFormId: '',
      rowData: {},
      auditForm: {},
      currentTab: 3,
      perfectScrollbarSettings: {
        maxScrollbarLength: 10,
        wheelPropagation: false,
      },
      formRefformData: {},
      dataNotice: [],
      dataMessage: [],
      contentShow: false,
      currentNotice: {},
      dropdown: false,
    }
  },
  filters: {
    filterTodoNum(num) {
      return num > 99 ? '99+' : num
    },
  },
  computed: {
    filterNum() {
      const num =
        this.total +
        this.dataMessage.filter((o) => o.readStatus !== 1).length +
        this.dataNotice.filter((o) => o.readStatus !== 1).length

      return num
    },
    auditOption() {
      const columns = [
        {
          label: this.i18n('isPass'),
          field: 'isPass',
          formOption: {
            type: 'radio',
            rules: 'required',
            dictData: [
              {
                label: 'Agree',
                value: true,
              },
              {
                label: 'Reject',
                value: false,
              },
            ],
          },
        },
        {
          label: this.i18n('comment'),
          field: 'comment',
          formOption: {
            type: 'textarea',
            maxlength: 2000,
            rules:
              typeof this.auditForm.isPass === 'boolean' &&
              !this.auditForm.isPass
                ? 'required'
                : '',
          },
        },
      ]
      const option = {
        columns,
      }
      return option
    },
  },
  watch: {
    contentShow(e) {
      if (!e) {
        setTimeout(() => {
          this.dropdown = false
        }, 500)
      } else {
        this.dropdown = true
      }
    },
    confirmModalShow(e) {
      if (!e) {
        this.auditForm = {}
      }
    },
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      todoAPi.getList(1, -1).then((res) => {
        const { data } = res.data
        this.total = data.total
        this.data = data.records
        this.auditForm = {}
      })
      todoAPi.noticeList(1, 10, { type: 1 }).then((res) => {
        const temp = res.data.data.records
        // 对web仅有的通知过滤
        if (temp.length) {
          this.dataNotice = temp.filter((el) => {
            if (el.payload) {
              const { params } = JSON.parse(el.payload)
              let deviceType = true
              if (params && params.type && params.type === 'app') {
                deviceType = false
              }
              return deviceType
            }
            return true
          })
        } else {
          this.dataNotice = []
        }
      })
      todoAPi.noticeList(1, 10, { type: 2 }).then((res) => {
        const temp = res.data.data.records
        // 对web仅有的通知过滤
        if (temp.length) {
          this.dataMessage = temp.filter((el) => {
            if (el.payload) {
              const { params } = JSON.parse(el.payload)
              let deviceType = false
              if (params && params.type && params.type !== 'app') {
                deviceType = true
              }
              return deviceType
            }
            return true
          })
        } else {
          this.dataMessage = []
        }
      })
      // todoAPi.queryNoticeList(1, -1, { readStatus: 0 }).then(res => {
      //   const temp = res.data.data.records
      //   this.dataNotice = temp.filter(o => o.type === 2)
      //   this.dataMessage = temp.filter(o => o.type === 1)
      // })
    },
    handleAudit() {
      this.modalShow = true
    },
    // i18n
    i18n(param) {
      return this.$t(`_todo.${param}`)
    },
    handleBeforeClose(done) {
      done()
    },
    handleDrawerClose() {
      this.drawerShow = false
    },
    handleViewClick(item) {
      console.log(item, 'sss')
      const payload = JSON.parse(item.payload)
      console.log(payload, 'payload')
      const params = payload.params
      console.log(payload, params)
      if (params.formId && params.id) {
        console.log('skkk')
        this.MessageProcessId = params.id
        this.MessageFormId = params.formId
        this.drawerShow = true
      }
    },
    handleAuditClick(row) {
      console.log('row', row)
      this.rowData = row
      const variables = row.variables || {}
      let option = ''
      //代表节点走到了29表单需要发起人上传机票的节点
      if (
        variables.formId == 29 &&
        (row.taskName === 'Applicant Upload Tickets' ||
          row.taskName === '发起人上传机票')
      ) {
        option =
          '{"component":"CVEditPage","params":[{"key":"processId","value":"processId"}]}' ||
          '{}'
      } else {
        option = variables.option || '{}'
      }

      const parseOption = JSON.parse(option)
      const parmasArr = parseOption.params || []
      const parmas = {}
      parmasArr.forEach((item) => {
        parmas[item.key] = variables[item.value]
      })
      this.componentParams = parmas
      this.getComponentByOption = parseOption.component
      this.modalShow = true
    },
    changeCurrentTab(num) {
      this.currentTab = num
    },
    handleContentClick(row) {
      todoAPi.noticeView(row.id).then((res) => {
        this.currentNotice = res.data.data.messageNoticeEntity
        this.contentShow = true
        this.onLoad()
      })
    },
    handleReadRow(row) {
      todoAPi.noticeView(row.id).then((res) => {
        this.currentNotice = res.data.data.messageNoticeEntity
        this.onLoad()
      })
    },
    dropdownHide(e) {
      if (this.dropdown) {
        e.preventDefault()
      }
    },
    formConfirm(e) {
      console.log('ssdfdf', this.$refs.formRef)
      if (
        this.$refs.formRef &&
        this.$refs.formRef.data &&
        this.$refs.formRef.data.leaveStartTime
      ) {
        const nowYear = moment().format('YYYY')
        const startYear = moment(this.$refs.formRef.data.leaveStartTime).format(
          'YYYY'
        )
        console.log('startYear', startYear, nowYear)
        if (startYear > nowYear) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text:
                'The leave days falls in the new year and will be automatically approved by the system on the first working day of the new year',
              variant: 'danger',
            },
          })
          return
        }
      }

      const that = this
      if (this.getComponentByOption === 'CVEditPage') {
        this.$refs.formRef.$refs.overFormRef.validationForm().then((r) => {
          if (r) {
            that.formRefformData = that.$refs.formRef.formatData
            that.confirmModalShow = true
          } else {
            that.formRefformData = {}
          }
        })
      } else {
        that.formRefformData = {}
        that.confirmModalShow = true
      }
    },

    handleDetailClick(row) {
      const option = JSON.parse(row.payload)
      const formIdArr = ['22', '101', '102', '103', '104']

      if (option) {
        console.log(option)
        if (option.params) {
          if (formIdArr.includes(option.params.formId)) {
            console.log('sss')
            this.$store.commit('SET_PROCESS_PARAMS', option.params)
          }
        }
        if (option.router) {
          this.$router.push({
            path: option.router,
            query: option.params,
          })
        }
      }
    },
    handleModelConfirm(selected) {
      console.log('parmas', this.formRefformData)
      this.auditLoading = false
      this.$refs.overFormRef.validationForm().then((r) => {
        if (r && !this.auditLoading) {
          this.auditLoading = true
          const params = deepClone(this.auditForm)
          if (params.isPass) {
            params.flag = 'ok'
          }

          params.taskId = this.rowData.taskId
          params.processDefinitionId = this.rowData.processDefinitionId
          params.processInstanceId = this.rowData.processInstanceId
          if (this.getComponentByOption === 'CVEditPage') {
            params.variables = {
              ...this.rowData.variables,
              ...this.formRefformData,
            }
          } else {
            params.variables = this.rowData.variables
          }

          console.log(params, this.formRefformData)

          delete params.isPass

          todoAPi
            .completeTask(params)
            .then((res) => {
              this.confirmModalShow = false
              this.modalShow = false
              this.auditLoading = false
              this.onLoad()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('_default.toast.title'),
                  icon: 'BellIcon',
                  text: this.$t('_default.toast.text.success'),
                  variant: 'success',
                },
              })
            })
            .catch(() => {
              this.auditLoading = false
            })
        }
      })
    },
    handleRead() {
      const obj = {
        1: 2,
        2: 1,
      }
      todoAPi.readAll({ type: obj[this.currentTab] }).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        this.onLoad()
      })
      // if (this.selectedNotice.length > 0) {
      //   const ids = this.selectedNotice.join()
      //   todoAPi.noticeMarkRead({ ids }).then(res => {
      //     this.$toast({
      //       component: ToastificationContent,
      //       props: {
      //         title: this.$t('_default.toast.title'),
      //         icon: 'BellIcon',
      //         text: this.$t('_default.toast.text.success'),
      //         variant: 'success',
      //       },
      //     })
      //     this.onLoad()
      //   })
      // } else {
      //   this.$toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: this.$t('_default.toast.title'),
      //       icon: 'BellIcon',
      //       text: this.$t('_components.message.notSelectData'),
      //       variant: 'danger',
      //     },
      //   })
      // }
    },
    markNoticeRead() {
      todoAPi
        .noticeMarkRead({ ids: this.currentNotice.noticeId })
        .then((res) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
          this.onLoad()
        })
    },
    pageChange() {
      if (this.currentTab === 3) {
        this.$router.push({ path: '/myApplication/todoData' })
      } else if (this.currentTab === 2) {
        this.$router.push({ path: '/myApplication/message' })
      } else if (this.currentTab === 1) {
        this.$router.push({ path: '/myApplication/message' })
      }
    },
    formatTime(e) {
      return e
    },
  },
}
</script>

<style lang="scss" scoped>
.media-list {
  height: 25rem;
  position: relative;
  overflow: auto;
  .media {
    position: relative;
    .media-heading {
      color: #bbb !important;
    }
  }
  .media-todo-list {
    .media-heading {
      color: #6e6b7b !important;
    }
  }
  .media-time {
    color: var(--192168102218-silver, var(--color-grey-73, #bbb));

    /* 192.168.102.218/Semantic/Item */
    font-family: var(--font-family-Font-1, Montserrat);
    font-size: var(--font-size-14, 14px);
    font-style: normal;
    font-weight: var(--font-weight-400, 400);
    line-height: var(--font-size-21, 21px); /* 150% */
    letter-spacing: var(--letter-spacing-0_14, 0.14px);
  }
  .media-content {
    width: 100%;
    max-width: 430px;
    color: var(--HR-AIIS-Dolphin, #6e6b7b);
    max-height: 200px;

    display: -webkit-box; /* 使用弹性盒布局 */
    -webkit-box-orient: vertical; /* 垂直排列盒子 */
    -webkit-line-clamp: 5; /* 限制为5行 */
    overflow: hidden; /* 隐藏超出部分 */
    text-overflow: ellipsis; /* 显示省略号 */

    /* 192.168.102.218/Semantic/Item */
    font-family: var(--font-family-Font-1, Montserrat);
    font-size: var(--font-size-14, 14px);
    font-style: normal;
    font-weight: var(--font-weight-400, 400);
    line-height: var(--font-size-21, 21px); /* 150% */
    letter-spacing: var(--letter-spacing-0_14, 0.14px);
  }
  .audit-btn {
    display: inline-block;
    transform: translateY(-3px);
  }
  &__btns {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    z-index: 2;
  }
  &__btns2 {
    position: absolute;
    top: 20px;
    right: 10px;
    transform: translateY(-50%);
    z-index: 2;
  }
  &__empty {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }
  .is-not-read {
    position: relative;
    overflow: hidden;
    background-color: #fff;
    .media-heading {
      color: #6e6b7b !important;
    }
    &:hover {
      background-color: #ecf4ff !important;
    }
    // &::before {
    //   content: '';
    //   position: absolute;
    //   left: -5px;
    //   top: -5px;
    //   width: 10px;
    //   height: 10px;
    //   transform: rotate(45deg);
    //   background: red;
    // }
  }
}
.media-btns {
  height: 4rem;
  line-height: 4rem;
  border-top: 1px solid #ebe9f1;
  background: rgb(247, 247, 247);
  border-radius: 0 0 5px 5px;
  display: flex;
  text-align: center;
  user-select: none;
  & > div {
    width: 100%;
    border-right: 1px solid #ebe9f1;
    justify-content: center;
    cursor: pointer;
    &:hover {
      color: #7367f0;
    }
  }
  & > div:last-child {
    border-right: none;
  }
}
</style>
<style lang="scss">
.process-modal {
  & > div {
    height: 80vh;
    overflow-y: auto;
    .my-form {
      height: auto;
    }
  }
}
.dropdown-notification {
  .dropdown-menu {
    padding: 0px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  }
  .current {
    background: #9591f1;
    color: #ffffff !important;
  }
  .dropdown-menu-header {
    background: rgb(248, 248, 248);
    & > div {
      border-right: 1px solid #ebe9f1;
      min-width: 150px;
      justify-content: center;
      cursor: pointer;
      // &:hover {
      //   background: #fff;
      // }
    }
    & > div:last-child {
      border-right: none;
    }
  }
  .dropdown-menu-media {
    width: auto !important;
  }
  .media-heading {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #6e6b7b;
    /* 192.168.102.218/Semantic/Heading 4 */
    font-family: var(--font-family-Font-2, 'PingFang SC');
    font-size: var(--font-size-18, 18px);
    font-style: normal;
    font-weight: var(--font-weight-500, 500);
    line-height: var(--line-height-21_6, 21.6px); /* 120% */
    letter-spacing: var(--letter-spacing-0_14, 0.14px);
  }
}
.notice-content {
  min-height: 300px;
}
.notice-footer {
  text-align: right;
  p {
    margin-top: 200px;
  }
}
.is-read {
  .media-heading {
    color: #c0c0c0 !important;

    /* 192.168.102.218/Semantic/Heading 4 */
    font-family: var(--font-family-Font-2, 'PingFang SC');
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 21.6px !important; /* 120% */
    letter-spacing: 0.14px;
  }
  .media-time {
    color: #bbb !important;
  }
  .media-content {
    color: #bbb !important;
  }
}
.media {
  padding: 12.6px 17.92px 13.6px 20px !important;
}
.dropdown-notification .dropdown-menu-header > div {
  min-width: 161px;
}
</style>
<style lang="scss" scoped>
.msg-box {
  position: relative;
  .msg-num {
    position: absolute;
    top: -10px;
    right: -10px;
    color: #ffffff;
    background-color: #ea5455 !important;
    border-radius: 8px;
    padding: 2px 5px;

    text-align: center;
    font-size: 12px;
  }
}
.message-viewBtn {
  width: 60px;
  text-align: center;
  border-radius: 4px;
  padding: 8px;
  color: #ffffff;
  background-color: #7367f0 !important;
}
</style>
